
import { PayloadAction } from '@reduxjs/toolkit'

import { ActionParams } from '@probatix/common/utils/service'

import { authServiceActions } from '@probatix/common/services/toolkit/auth'
import { removeToken } from '../services/services.helpers'

type Action = PayloadAction<ActionParams<object>>

const logoutMiddleware = () => () => (next) => async (action: Action) => {
  if (!authServiceActions.logout.match(action)) {
    return next(action)
  }

  // NOTE: middleware used for all of the probatix services to logout user from all of the serivces based on
  // the single sign on
  removeToken()

  return next(action)
}

export default logoutMiddleware
